import { fetchJSON } from '@bonnet/next/fetch';

const options = {
    credentials: 'omit',
    headers: {
        'X-fwd-svc': 'atc',
        'Content-Type': 'application/json',
    },
    circuitBreaker: {
        id: 'vehicleSummary',
        timeout: 70000, // proxy timeout is 60s, so set this higher
        resetTimeout: 300000,
        fallback: {},
    },
};

export default ({ vehicleDetails }) => fetchJSON('/agent', {
    ...options,
    body: {
        message: `Provide a short summary of what's great about the following vehicle: ${JSON.stringify(vehicleDetails)}. Format your response in the following way: [brief intro stating basic car info] [16px spacing] [bulleted list titled "Key Highlights"- include details about price, mileage, engine, and fuel economy] [16px spacing] [bulleted list titled "Key Features" - include a maximum of 5] [16px spacing] [two sentence summary describing what's great about the vehicle]. Format the response only with valid html. Use <strong> tags to bold titles, <ul> tags for bulleted lists, <li> tags for list items, and <br> tags for line breaks.`,
        sessionContext: {},
    },
    method: 'POST',
});
